module.exports = __webpack_public_path__ + "img/182.8b1a90ad.jpg";